var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-control',{attrs:{"type":"radio","label":"Wersja EKO","name":"eko_version","items":_vm.ekoStatusTypes},model:{value:(_vm.ekoStatus),callback:function ($$v) {_vm.ekoStatus=$$v},expression:"ekoStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }